import { BuscarService } from 'src/app/services/buscar.service';
import { alertaConfirmacion, alertaConfirmacionHTML, basicAlert, basicAlertHTML, filtrarCoincidenciaArrayTransportista, obtenerFechaActual, obtenerFechaSeleccionada, openDescripcion, openObservacion, openReutilizar, setConfigTable, setConfigTableBuscador, timerOut } from 'src/app/shared/utils';
import { ArticuloService } from 'src/app/services/articulo.service'
import { SpinnerService } from 'src/app/services/spinner.service';
import { ModalBusquedaProveedorComponent } from 'src/app/shared/modals/busqueda/modal-busqueda-proveedor/modal-busqueda-proveedor.component'
import { ModalBusquedaArticulosComponent } from 'src/app/shared/modals/busqueda/modal-busqueda-articulos/modal-busqueda-articulos.component'
import { ModalArticuloEspecificacionComponent } from 'src/app/shared/modals/modal-tabs-articulos/modal-tab-especificaciones.component'
import { InterlocutorService } from 'src/app/services/iInterlocutor.service';
import { iArticulo } from 'src/app/models/iarticulomodel'
import { objArticulo, objClaseCodigoDescripcion, objArticuloEspecificacion } from 'src/app/models/objarticulo.model'
import { ProveedorService } from 'src/app/services/proveedor.service'
import { Subject } from 'rxjs';
import { NgbModal, NgbModalRef, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { ImagenBase64 } from 'src/app/models/imagenBase64.model';
import { DomSanitizer } from '@angular/platform-browser';
import { StorageService } from 'src/app/services/storage.service'
import { UnidadService } from 'src/app/services/unidad.service';
import { RecursosService } from 'src/app/services/recursos.service';
import { DataService } from 'src/app/services/dataService.service';
import { TFactorService } from 'src/app/services/TFactor.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import * as FileSaver from 'file-saver';
import { ModalBusquedaCodclaartComponent } from '../../busqueda/modal-busqueda-codclaart/modal-busqueda-codclaart.component';

@Component({
  selector: 'app-modificar-articulo',
  templateUrl: './modificar-articulo.component.html',
  styleUrls: ['./modificar-articulo.component.css']
})
export class ModificarArticuloComponent implements OnInit {
 //VARIABLE SESSION 
 sessionInfo: any
 public updatebandera: boolean = false

 //VARIABLE DESHABILITA CAMPOS
 disabledcampo: boolean = true
 disabledTipoInventario: boolean = false;

 closeResult = '';
 //VARIABLES TAB CLASES
 dtTrigger: Subject<null> = new Subject();
 dtOptions: any = {};
 clases: any[] = [];
 clasesCodigos: any[] = [];
 viewInterfazClasesPrin = 1;
 public objClaseCodigoDescripcion = new objClaseCodigoDescripcion();
 public objEAN : any = {};
 public newClase: boolean = false;

 public editclase: any;
 public _codigo: string = null;
 //lista de clases select
 clasesSelect = []
 imagenAdjunto: any;

 //VARIABLES TAB ESPECIFICACIOES
 especificaciones: any[] = [];
 public objClaseCodigoEspecifi = new objArticuloEspecificacion();
 clasesSelectEspecificaciones = []
 disabledDecimal: boolean = true
 disabledTexto: boolean = true
 disabledCaracter: boolean = true
 disabledFecha: boolean = true
 disabledTiempo: boolean = true
 disabledNumero: boolean = true
 decimal: any;
 texto: any;
 caracter: any;
 fecha: any;
 tiempo: any;
 numero: any;
 _especificacion: any
 _descriespecificacion: any
 public editespecificacion: any;
 /***********************/

 //VARIABLES TAB LISTA DE PRECIO
 listaPreciosArticulo: any[] = [];
 listean: any[] = [];
 //VARIABLES TAB CLASES GLOBALES 
 clasesGlobalesSelect: any[] = [];
 clasesAlternativasSelect: any[] = [];

 clasesGlobales: any[] = [];
 clasesAlternativas: any[] = [];

 public objClaseGlobal = new objClaseCodigoDescripcion();
 public objClaseAltenativa : any;

 public _codigoglobal: string = null;
 clasesCodigosGlobal: any[] = [];
 editclaseGlobal: any;
 editclaseAlt: any;

 //VARIABLES TAB IMAGENES 
 public tabImagenes: boolean = false;
 public tabVerImagen: boolean = true;
 public imagenesArticulo: any[] = [];
 arregloPrueba: any[] =[];

 tab: string = 'imagenes';
 public objImagen = new ImagenBase64();
 public objAdjunto: any;

 public image: any;
 public formato: string;
 public size: number;
 public codImagen: string = ''
 public disabledbotonImagen: boolean = true;
 public imagen: any;

 @ViewChild('fileUpload') fileUpload: ElementRef;

 //VARIABLES TIPO DE INVENTARIO 
 public tiposInventario: any[] = [];
 public codTipoInventario: number = 1;

 //VARIABLES UNIDAD DE MEDIDA
 public unidadesMedidas: any[] = [];
 public codUnidadMedida: number;

 //VARIABLES CONTROL DE STOCK
 public tipoControlStock: any[] = [];

 // VARIABLES DEL FORMULARIO
 public desControlStock: string = 'Controla stock unidades';
 public inputAgrupa: boolean;
 public inputPagoAdelantado: boolean;
 public comentarioApp: any;
 public codFabricante: any;
 public mostrarbotoneliminar: boolean = true

 //Articulo
 public objarticulo = new objArticulo()
 public desProveedor: String = ''

 /*******MODAL INTERLOCUTOR******/

 disabledProveedor: boolean = true;
 buscarProveedor: string = 'buscar';


 @ViewChild('razon') razon: ElementRef;
 @ViewChild('plazaentrega') plazaentrega: ElementRef;
 @ViewChild('codFabri') codFabri: ElementRef;
 @ViewChild('provee') provee: ElementRef;
 @ViewChild('selectTipoInventario') selectTipoInventario: ElementRef;
 @ViewChild('selectunidadesMedidas') selectunidadesMedidas: ElementRef;
 @ViewChild('desarticulo') desarticulo: ElementRef;
 @ViewChild('modalnuevaespecificacion') modalnuevaespecificacion: ElementRef;
 /******************************/

 /*******MODAL PROVEEDOR******/
 proveedores: any[] = [];

 /*******MODAL ARTICULOS*****/
 articulos: any[] = [];
 disabledArticulo: boolean = false;
 buscarArticulo: string = 'buscar';
 buscarcodCla: string = 'buscar';

 /******TABS MODIFICAR ***/
 public tabclases: boolean = false;
 public tabespecificaciones: boolean = false;
 public tabimagenes: boolean = false;
 public tabclasesglobales: boolean = false;
 public tablistprecios: boolean = false;
 public _recursos: any = {};


 /********************************/
 detraccion: any = {}
 detracciones: any[] = [];
 operaciones: any[] = [];
 bienes_servicios: any[] = [];
 disabcod: boolean = false

 @Input() tipinv;
 @Input() codart;
 @Input() doc_adjuntos: any ;

 modal : NgbModalRef;
 constructor(
   private _buscarService: BuscarService,
   private unidadMedidaService: UnidadService,
   private articuloService: ArticuloService,
   private spinnerService: SpinnerService,
   private modalService: NgbModal,
   private provedorService: ProveedorService,
   private recursosService: RecursosService,
   public dataService: DataService,
   private tfactorService: TFactorService,
   private toastr: ToastrService,
   private router: Router,
   private _route: ActivatedRoute,
   private modalService2: NgbActiveModal,
   private _sanitizer: DomSanitizer
 ) { 
  //  this.tipinv =  this._route.snapshot.paramMap.get('tipinv');
  //  this.codart =  this._route.snapshot.paramMap.get('codart');

 }

 ngOnInit(): void {
  this.tipoglosa = 1,

  this.doc_adjuntos= [];
   this.spinnerService.activarLoading(true);
   this.recursosService.recursosArticulo().subscribe((resp: any) => {
     this.spinnerService.activarLoading(false);

     this._recursos = resp.body;

     if (this._recursos != null && this._recursos.inventarios != null)
       this.tiposInventario = this._recursos.inventarios;
     if (this._recursos != null && this._recursos.unidades != null)
       this.unidadesMedidas = this._recursos.unidades;
     if (this._recursos != null && this._recursos.controlStocks != null)
       this.tipoControlStock = this._recursos.controlStocks;

     this.objarticulo = new objArticulo()
     console.log('TIPINV',this.tipinv,'CODART',this.codart)
     this.codTipoInventario=this.tipinv;
     this.objarticulo.tipinv = this.tipinv;
     this.objarticulo.fmatri = obtenerFechaActual('YYYY-MM-DD')
     this.objarticulo.faccon = (Number.parseFloat('1').toFixed(4));
     this.objarticulo.consto = 1;
     this.objarticulo.codprv = ''
     this.desProveedor = ''
     console.log('Si toma valor:' + this.objarticulo.fmatri)

     timerOut(5).then((value: any) => {
       if (value) { this.selectTipoInventario.nativeElement.focus(); }
     })

   }, err => {
     this.spinnerService.activarLoading(false);
   });

   this.getByCodArticulo(this.tipinv, this.codart, 2);
   this.getAdjuntos();
   this.getlistaClasesAlternativas();
   //this.getListImage();
  //  this.getGlosa();
   setTimeout(() => {
    
    // this.getGlosa();
  }, 150);
 }



 private getListDetraccion() {
   this.tfactorService.buscar(64).subscribe((response: any) => {
     console.log(response);
     this.detracciones = response.body;
     this.spinnerService.activarLoading(false);
   }, err => {
     basicAlert(`No hay lista de detracciones`, 'warning', 'Aceptar');
     this.spinnerService.activarLoading(false);
   });
 }

 private getListOperacion() {
   this.tfactorService.buscar(300).subscribe((response: any) => {
     console.log(response);
     this.operaciones = response.body;
     this.spinnerService.activarLoading(false);
   }, err => {
     basicAlert(`No hay lista de operaciones`, 'warning', 'Aceptar');
     this.spinnerService.activarLoading(false);
   });
 }


 private getListBienServico() {
   this.tfactorService.buscar(301).subscribe((response: any) => {
     console.log(response);
     this.bienes_servicios = response.body;
     this.spinnerService.activarLoading(false);
   }, err => {
     basicAlert(`No hay lista de bienes o servicio`, 'warning', 'Aceptar');
     this.spinnerService.activarLoading(false);
   });
 }

 ngOnDestroy() {
   this.dataService.vista = 0;
   console.log("On Destroy");
 }

 public messageTable = {
   emptyMessage: 'No hay información',
   totalMessage: 'total',
   selectedMessage: 'selected'
 }



 private getProveedores() {

   this.provedorService.buscarProveedor('', '', '', 60, 0, true).subscribe((resp: any) => {
     console.log(resp)
     console.log(resp.body);

   }, err => {

   })
 }

 private getArticulos() {
   //10117 y 100
   let tipinv = 100
   let cod = 10117
   //this.articuloService.obtener_articulo(tipinv,cod).subscribe((resp: any) => {
   this.articuloService.buscar('', '', '', 60, 0).subscribe((resp: any) => {
     console.log(resp)
     console.log(resp.body);

   }, err => {

   })
 }

 keyUpControlStock(val: any) {
   if (val > 8) {
     this.objarticulo.consto = 8;
   }
   if (val < 0) {
     this.objarticulo.consto = 0;
   }
   this.tipoControlStock.forEach(element => {
     if (element.tipo == val) {
       this.desControlStock = element.descripcion;
     }
   });
 }

 asignarDecimalesFacConversion(val: any) {
   this.objarticulo.faccon = (Number.parseFloat(val).toFixed(4));
 }

 retornarEnter(e) {
   this.retornoEnter(e);
   return (this.retornoEnter(e) != 13);
 }

 retornoEnter(e) {
   let tecla: any;
   return tecla = (document.all) ? e.keyCode : e.which;
 }


 /*************INPUT CON MODAL**********/
 /**************INPUT MODAL ARTICULO************************/



 onBlurCodArticulo(codart: string) {
   if (codart != '') {
     this.getByCodArticulo(this.objarticulo.tipinv, codart, 2);
   }
 }

 getByCodArticulo(tipinv: number, codart: string, tipoSearch: number) {
   
   this.spinnerService.activarLoading(true);
   this.detraccion.tasdet = null;
   this.detraccion.tipope = null;
   this.detraccion.tipbys = null;
   this.sessionInfo = JSON.parse(StorageService.getSession());
   this.articuloService.obtener_articulo(tipinv, codart).subscribe((response: any) => {
     console.log('Informacion sesion:---')
     console.log(this.sessionInfo)
     setTimeout(()=>{
      this.objarticulo.codart = response.body.codart
      this.objarticulo.descri = response.body.descri
      this.objarticulo.fmatri = response.body.fmatri
      this.objarticulo.codbar = response.body.codbar
      this.objarticulo.agrupa = response.body.agrupa
      this.objarticulo.consto = response.body.consto
      this.objarticulo.coduni = response.body.coduni
      this.objarticulo.proart = response.body.proart
      this.objarticulo.codoem = response.body.codoem

      this.objarticulo.wglosa = response.body.wglosa
      this.objarticulo.conesp = response.body.conesp
      this.objarticulo.tipinv = response.body.tipinv
      this.objarticulo.fcreac=response.body.fcreac;
      this.objarticulo.factua=response.body.factua;
      this.objarticulo.ucreac=response.body.ucreac;
      this.objarticulo.uactua=response.body.uactua;

     /////////////////////////////////
     console.log("this.objarticulo.agrupa")
     console.log(this.objarticulo.agrupa)
     console.log("this.objarticulo.conesp")
     console.log(this.objarticulo.conesp)

     if (this.objarticulo.agrupa == 'S') {
      this.inputAgrupa = true;
    } else {
      this.inputAgrupa = false;
    }

    if (this.objarticulo.conesp == 1) {
      this.inputPagoAdelantado = true;
    } else {
      this.inputPagoAdelantado = false;
    }

  

     },800)
    
    
     this.mostrarbotoneliminar = false;
     this.tabclases = true;
     this.tabespecificaciones = true;
     this.tabimagenes = true;
     this.tabclasesglobales = true;
     this.tablistprecios = true;

     this.disabledcampo = false;
     this.disabledProveedor = false;
     this.disabledTipoInventario = true;

     //INFORMACION DE TABS
     if (response.body.claseAlternativos != null) {
      this.clasesAlternativas = response.body.claseAlternativos;
    }
     if (response.body.clases != null) {
       this.clases = response.body.clases;
     }
  
    //  claseAlternativos: this.clasesAlternativas,


     if (response.body.codprv != null)
       this.getByCodProveedor(response.body.codprv, 2)
     this.asignarDecimalesFacConversion(response.body.faccon)
     this.selectModalEspecificacion();
     this.getlistaPrecioArticulos(tipinv, codart)
     this.getlistaEANArticulos(tipinv, codart)
     this.articuloService.listaArticuloImagenes(this.objarticulo.tipinv, codart).subscribe({
      next: (res) => {
       this.arregloPrueba = res.body;
      },
      error: (err) => { 
        this.spinnerService.activarLoading(false);
        console.error('Error al obtener la lista de imágenes:', err);
      }
    });
     //this.getImagen(tipinv,codart)

     this.tipoControlStock.forEach(element => {
       if (element.tipo == response.body.consto) {
         this.desControlStock = element.descripcion;
       }
     });

     timerOut(10).then((value: any) => {
       if (value) { this.selectunidadesMedidas.nativeElement.focus(); }
     });

     this.disabledArticulo = true;
     this.buscarArticulo = 'borrar';

     this.dataService.vista = 1;
     this.dataService.tipo = 'articulo';

     this.getListDetraccion();
     this.getListOperacion();
     this.getListBienServico();
     if (response.body.detraccion != null) {
       this.detraccion = response.body.detraccion;
     }
     else {

     }
     this.detraccion.codart = response.body.codart;
     this.detraccion.tipinv = response.body.tipinv;
     setTimeout(() => {
      this.getGlosa();
    }, 825);
     this.spinnerService.activarLoading(false);
   }, err => {
     this.spinnerService.activarLoading(false);
     if (err.status == 404) {
       basicAlert('No se encontró información para el articulo seleccionado', 'warning', 'Aceptar');
       this.mostrarbotoneliminar = true;
     }
     timerOut(10).then((value: any) => {
       if (value) { this.provee.nativeElement.focus(); }
     });
     this.objarticulo.codart = ''
     this.objarticulo.descri = ''
   });
 }

 onKeyEnterArticulo(e) {
   this.openModalArticulo();

   let tecla: any;
   tecla = (document.all) ? e.keyCode : e.which;
   return (tecla != 13);
 }

 onKeyEnterCodArticulo(e) {
   this.onBlurCodArticulo(this.objarticulo.codart);
 }

 onKeyEnterCodigoArticulo(e) {
   this.openModalCodArticulo();

   let tecla: any;
   tecla = (document.all) ? e.keyCode : e.which;
   return (tecla != 13);
 }

 openModalCodArticulo() {
   let codpro: string = this.objarticulo.codart+"%";
   let razonc: string = '';
   let limit: number = 60;
   let offset: number = 0;

   if (this.objarticulo.codart.length > 0) {
     this.spinnerService.activarLoading(true);
     this.articuloService.buscar(this.objarticulo.tipinv, codpro, razonc, limit, offset).subscribe((response: any) => {
       console.log('lista de articulos')
       console.log(response.body);
       this.articulos = response.body;
       if(this.articulos.length >1){
         this.mostrarModalArticulo();
       }else{
         console.log(this.articulos[0])
         this.objarticulo.codart = this.articulos[0].codart
         this.onBlurCodArticulo(this.objarticulo.codart)
       }
     
     }, err => {
       console.log(err);
       if (err.status == 404) {
         basicAlert('No se encontró la lista de articulos.', 'warning', 'Aceptar', null, null, this.razon);
       }
       this.spinnerService.activarLoading(false);
     });
   } else {
     basicAlert('Para activar la ayuda ingresar mínimo 1 caracter.', 'warning', 'Aceptar', null, null, this.razon);
     return;
   }
 }

 openModalArticulo() {
   let codpro: string = '';
   let razonc: string = this.objarticulo.descri + "%";
   let limit: number = 60;
   let offset: number = 0;

   console.log(this.objarticulo.tipinv + razonc)

   if (this.objarticulo.descri.length > 0) {
     this.spinnerService.activarLoading(true);
     this.articuloService.buscar(this.objarticulo.tipinv, codpro, razonc, limit, offset).subscribe((response: any) => {
       console.log('lista de articulos')
       console.log(response.body);
       this.articulos = response.body;
       this.mostrarModalArticulo();
     }, err => {
       console.log(err);
       if (err.status == 404) {
         basicAlert('No se encontró la lista de articulos.', 'warning', 'Aceptar', null, null, this.razon);
       }
       this.spinnerService.activarLoading(false);
     });
   } else {
     basicAlert('Para activar la ayuda ingresar mínimo 1 caracter.', 'warning', 'Aceptar', null, null, this.razon);
     return;
   }
 }

 mostrarModalArticulo() {
   const referenciaModal = this.modalService.open(ModalBusquedaArticulosComponent, { scrollable: true, windowClass: 'modal-lista-articulos', backdrop: 'static' });
   referenciaModal.componentInstance.articulos = this.articulos;
   referenciaModal.result.then((data) => {
     console.log(data);
     this.getByCodArticulo(data.tipinv, data.codart, 2)
   }, (reason) => {
     console.log(reason);
   });
 }

 mostrarModalTabEspecificion() {
   this.spinnerService.activarLoading(true)
   const referenciaModal = this.modalService.open(ModalArticuloEspecificacionComponent, { scrollable: true, windowClass: 'modal-lista-articulos', backdrop: 'static' });
   referenciaModal.componentInstance.clasesSelectEspecificaciones = this.clasesSelectEspecificaciones;
   referenciaModal.result.then((data) => {
     this.spinnerService.activarLoading(false)
     //  this.selectModalEspecificacion();
     console.log(data);
     this.disabledDecimal = data.vreal
     this.disabledTexto = data.vstrg
     this.disabledCaracter = data.vchar
     this.disabledFecha = data.vdate
     this.disabledTiempo = data.vtime
     this.disabledNumero = data.ventero
     this._especificacion = data.codigo
     this._descriespecificacion = data.descri
     this.openModalSelecNuevaEspecificion()

     // this.getByCodArticulo(data.tipinv, data.codart, 2)
   }, (reason) => {
     this.spinnerService.activarLoading(false)
     console.log(reason);
     //this.selectModalEspecificacion();
   });
 }

 openModalSelecNuevaEspecificion() {
   console.log('abrir modal')
   this.open(this.modalnuevaespecificacion)
  //  this.modalService.open(this.modalnuevaespecificacion, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {

  //    this.closeResult = `Closed with: ${result}`;
  //  }, (reason) => {
  //    this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
  //  });
 }

 borrarArticulo() {

   this.objarticulo.codart = ''
   this.objarticulo.descri = ''

 }

 borrarDatosArticulo() {
   this.borrarArticulo();
   this.cancelar();

   timerOut(10).then((value: any) => {
     if (value) { this.desarticulo.nativeElement.focus(); }
   });


   this.disabledArticulo = false;
   this.buscarArticulo = 'buscar';
   this.dataService.vista = 0;

 }

 /***************************************/

 /*************INPUT CON MODAL**********/
 /**************INPUT MODAL PROVEEDOR************************/

 onKeyEnterCodProveedor(e) {
   /* let tecla: any;
    tecla = (document.all) ? e.keyCode : e.which;
    return (tecla != 13);*/
   this.onBlurCodProveedor(this.objarticulo.codprv)
 }

 onBlurCodProveedor(codpro: string) {
   console.log(codpro)
   console.log('Hola mundo')
   if (codpro != '') {
     if (codpro != null)
       this.getByCodProveedor(codpro, 2);
   }
 }

 public calcular_precio_total(detalleListaPrecio: any) {

   let totalDsc1: number = 0.0;
   let totalDsc2: number = 0.0;
   let totalDsc3: number = 0.0;
   let totalDsc4: number = 0.0;

   let totaNeto: number = 0.0;

   totalDsc1 = detalleListaPrecio.precio * ((100 - detalleListaPrecio.desc01) / 100);
   totalDsc2 = totalDsc1 * ((100 - detalleListaPrecio.desc02) / 100);
   totalDsc3 = totalDsc2 * ((100 - detalleListaPrecio.desc03) / 100);
   totalDsc4 = totalDsc3 * ((100 - detalleListaPrecio.desc04) / 100);

   totaNeto = totalDsc4;

   return totaNeto;
 }

 getByCodProveedor(codpro: string, tipoSearch: number) {
   this.spinnerService.activarLoading(true);
   this.provedorService.obtenerProveedor(codpro, true).subscribe((response: any) => {
     this.spinnerService.activarLoading(false);
     this.updatebandera = true;
     this.objarticulo.codprv = response.body.codcli
     this.desProveedor = response.body.razonc
     this.disabledProveedor = true;
     this.buscarProveedor = 'borrar';
   }, err => {
     this.updatebandera = false
     this.spinnerService.activarLoading(false);
     console.log(err);
     if (err.status == 404) {
     }
     this.objarticulo.codprv = ''
     this.desProveedor = ''

   });
 }

 onKeyEnterProveedor(e) {
   this.openModalProveedor();

   let tecla: any;
   tecla = (document.all) ? e.keyCode : e.which;
   return (tecla != 13);
 }

 openModalProveedor() {
   let codpro: string = '';
   let razonc: string = this.desProveedor + "%";
   let nombres: string = '';
   let dident: string = '';
   let soloactivos: boolean = true;
   let limit: number = 60;
   let offset: number = 0;

   console.log(razonc)

   if (this.desProveedor.length > 0) {
     this.spinnerService.activarLoading(true);

     this.provedorService.buscarProveedor(codpro, razonc, dident, limit, offset, true).subscribe((response: any) => {
       console.log(response.body);
       this.proveedores = response.body;

       this.mostrarModalProveedor();
     }, err => {
       console.log(err);
       if (err.status == 404) {
         basicAlert('No se encontró la lista de proveedores.', 'warning', 'Aceptar', null, null, this.razon);
       }
       this.spinnerService.activarLoading(false);
     });
   } else {
     basicAlert('Para activar la ayuda ingresar mínimo 1 caracter.', 'warning', 'Aceptar', null, null, this.razon);
     return;
   }
 }

 mostrarModalProveedor() {
   const referenciaModal = this.modalService.open(ModalBusquedaProveedorComponent, { scrollable: true, windowClass: 'modal-lista-articulos', backdrop: 'static' });

   referenciaModal.componentInstance.proveedores = this.proveedores;

   referenciaModal.result.then((data) => {
     console.log(data);
     if (data.codpro != null)
       this.getByCodProveedor(data.codpro, 2)
   }, (reason) => {
     console.log(reason);
   });
 }

 borrarProveedor() {
   this.updatebandera = false;
   this.objarticulo.codprv = ''
   this.desProveedor = ''

 }

 borrarDatosProveedor() {

   this.borrarProveedor();

   timerOut(10).then((value: any) => {
     if (value) { this.provee.nativeElement.focus(); }
   });

   this.disabledProveedor = false;
   this.buscarProveedor = 'buscar';
 }

 /***************************************/



 /*************************TIPO DE INVENTARIO*************************************/
 onKeyEnterTipodeInventario(e) {
   if (this.objarticulo.tipinv != null) {

     if (e.which == 13) {
       if ($('#cboTipoInventario option:selected').text() == '') {
         this.objarticulo.tipinv = 1;
         setTimeout(() => {
           basicAlert('El código ingresado no existe.', 'warning', 'Aceptar', null, null, null);
         }, 200);
       }
     }
     /*let tecla: any;
     tecla = (document.all) ? e.keyCode : e.which;
     return (tecla != 13); */
   }
 }

 onBlurTipodeInventario(e) {
   console.log('onBlurTipodeInventario')
   if (this.objarticulo.tipinv != null) {
     if (e.which == 0) {
       //  this.FuncionesTSI.validacionBusquedaPorCodigoInput(this.codSucursal.toString(), '#cboSucursal option:selected', 'El código de sucursal no existe', 'warning', '#codSucursal', '#codInterlocutor');
       if ($('#cboTipoInventario option:selected').text() == '') {
         this.objarticulo.tipinv = 1;
         basicAlert('El código ingresado no existe.', 'warning', 'Aceptar', null, null, null);
       }
     }
   }
 }
 /**************************************************************/

 /*************************UNIDAD DE MEDIDA*************************************/
 onKeyEnterUnidadesMedida(e) {
   if (this.objarticulo.coduni != null) {
     setTimeout(() => {
       // this.FuncionesTSI.validacionBusquedaPorCodigoInput(this.codSucursal.toString(), '#cboSucursal option:selected', 'El código de sucursal no existe', 'warning', '#codSucursal', '#codInterlocutor');
     }, 200);
   }

   let tecla: any;
   tecla = (document.all) ? e.keyCode : e.which;
   return (tecla != 13);
 }

 onBlurUnidadesMedida(e) {
   if (this.objarticulo.coduni != null) {
     if (e.which == 0) {
       //  this.FuncionesTSI.validacionBusquedaPorCodigoInput(this.codSucursal.toString(), '#cboSucursal option:selected', 'El código de sucursal no existe', 'warning', '#codSucursal', '#codInterlocutor');
       if ($('#cboUnidadesMedida option:selected').text() == '') {
         this.objarticulo.coduni = null;
       }
     }
   }
 }
 /**************************************************************/

 //GUARDAR ARTICULO 

 guardar() {

   if (this.objarticulo.tipinv == null) {
     basicAlert('El campo tipinv es obligatorio.', 'warning', 'Aceptar', null, null, null);
     return;
   }

   if (this.objarticulo.codart == null) {
     basicAlert('El campo código es obligatorio.', 'warning', 'Aceptar', null, null, null);
     return;
   }

   if (this.objarticulo.descri == null) {
     basicAlert('El campo descripción es obligatorio.', 'warning', 'Aceptar', null, null, null);
     return;
   }

   if (this.objarticulo.coduni == null) {
     basicAlert('El campo unidad de medida es obligatoria.', 'warning', 'Aceptar', null, null, null);
     return;
   }

   if (this.objarticulo.faccon == null) {
     basicAlert('El campo factor de conversión es obligatorio.', 'warning', 'Aceptar', null, null, null);
     return;
   }

   if (this.inputAgrupa) {
     this.objarticulo.agrupa = 'S'
   } else {
     this.objarticulo.agrupa = 'N'
   }

   if (this.inputPagoAdelantado) {
     this.objarticulo.conesp = 1;
   } else {
     this.objarticulo.conesp = 0;
   }

   if (this.desProveedor == '' && this.objarticulo.codprv == '') {
     this.updatebandera = true
   }

   // if (this.updatebandera == false) {
   //   basicAlert('El codigo del proveedor no existe.', 'warning', 'Aceptar', null, null, null);
   //   return;
   // }
   console.log('Esto se envia a guardar:')
   console.log(this.objarticulo)

   let articulodata: any = {
     id_cia: this.objarticulo.id_cia,
     tipinv: this.objarticulo.tipinv,
     codart: this.objarticulo.codart,
     descri: this.objarticulo.descri,
     codmar: this.objarticulo.codmar,
     codubi: this.objarticulo.codubi,
     codprc: this.objarticulo.codprc,
     codmod: this.objarticulo.codmod,
     modelo: this.objarticulo.modelo,
     codobs: this.objarticulo.codobs,
     coduni: this.objarticulo.coduni,
     codlin: this.objarticulo.codlin,
     codori: this.objarticulo.codori,
     codfam: this.objarticulo.codfam,
     codbar: this.objarticulo.codbar,
     parara: this.objarticulo.parara,
     proart: this.objarticulo.proart,    
     codoem: this.objarticulo.codoem,
     consto: this.objarticulo.consto,
     codprv: this.objarticulo.codprv,
     agrupa: this.objarticulo.agrupa,
     fcreac: this.objarticulo.fcreac,
     fmatri: this.objarticulo.fmatri,
     factua: this.objarticulo.factua,
     usuari: this.objarticulo.usuari,
     wglosa: this.objarticulo.wglosa,
     faccon: this.objarticulo.faccon,
     tusoesp: this.objarticulo.tusoesp,
     tusoing: this.objarticulo.tusoing,
     diacmm: this.objarticulo.diacmm,
     cuenta: this.objarticulo.cuenta,
     conesp: this.objarticulo.conesp,
     linea: this.objarticulo.linea,
     proint: this.objarticulo.proint,
     codint: this.objarticulo.codint,
     codope: this.objarticulo.codope,
     situac: this.objarticulo.situac,

     stock: this.objarticulo.stock,
     precio: this.objarticulo.precio,
     codigosadd01: this.objarticulo.codigosadd01,
     codigosadd02: this.objarticulo.codigosadd02,
     clases: this.clases,
     clasesglobal: this.clasesGlobales,
     claseAlternativos: this.clasesAlternativas,
     imagenes: this.objarticulo.imagenes,
     codigosean: this.objarticulo.codigosean,
     especificaciones: this.especificaciones,
     detraccion: this.detraccion,
   }


   this.spinnerService.activarLoading(true);
   this.articuloService.modificar(articulodata).subscribe((resp: any) => {
     this.spinnerService.activarLoading(false);
     console.log(resp.body);
     this.toastr.success('Se actualizó correctamente.','',{ positionClass: 'toast-bottom-left'})

     // basicAlert('Se actualizó correctamente', 'success', 'Aceptar', null, null, this.desarticulo)
     this.cancelar()
   }, err => {
     this.spinnerService.activarLoading(false);
     basicAlert(err.message, 'warning', 'Aceptar', null, null, this.desarticulo)
   })
 }

 cancelar() {

   this.objarticulo.codprv = ''
   this.desProveedor = ''
   this.updatebandera = false;
   this.mostrarbotoneliminar = true

   this.tabclases = false;
   this.tabespecificaciones = false;
   this.tabimagenes = false;
   this.tabclasesglobales = false;
   this.tablistprecios = false;

   let lasTipinv: number = this.objarticulo.tipinv;

   this.objarticulo = new objArticulo()
   this.clases = []
   this.objarticulo.tipinv = lasTipinv;
   this.objarticulo.fmatri = obtenerFechaActual('YYYY-MM-DD')
   this.objarticulo.faccon = (Number.parseFloat('1').toFixed(4));
   this.objarticulo.consto = 1;

   this.inputAgrupa = false;
   this.inputPagoAdelantado = false;

   this.disabledArticulo = false;
   this.buscarArticulo = 'buscar';
   this.dataService.vista = 0;

   this.disabledProveedor = false;
   this.buscarProveedor = 'buscar';

   this.tipoControlStock.forEach(element => {
     if (element.codigo == this.objarticulo.consto) {
       console.log(element.descri);
       this.desControlStock = element.descri;
     }
   });

   this.disabledcampo = true;
   this.disabledTipoInventario = false;

   this.tipoglosa = 1,
   this.glosa = '' ,
   this.predeterminadoUpd = false
   timerOut(3).then((value: any) => {
     if (value) { this.desarticulo.nativeElement.focus(); }
   });

   this.arregloPrueba = [];
   this.objImagen = new ImagenBase64();
   this.codImagen = ''
   this.disabledbotonImagen = true;
   this.detracciones = null;

this.cerrar();
 }
 actualizarLista:boolean=false;
 eliminar() {

   alertaConfirmacion('¿Está seguro de eliminar el artículo?', 'warning', false, true)
     .then((responseAlert) => {
       if (responseAlert != undefined && responseAlert != null && responseAlert) {
         this.spinnerService.activarLoading(true);
         this.articuloService.eliminar(this.objarticulo.tipinv, this.objarticulo.codart).subscribe((resp: any) => {
           this.spinnerService.activarLoading(false);
           console.log(resp)
           this.toastr.success('Se eliminó correctamente.','',{ positionClass: 'toast-bottom-left'})
          this.actualizarLista=true;
           // basicAlert('Se eliminó correctamente.', 'success', 'Aceptar')
           this.cancelar();
         }, err => {
           this.spinnerService.activarLoading(false);
           console.log(err)
           basicAlert(err.error, 'error', 'Aceptar')
         })
       }
     })
 }


 onNexFocus(tipo: string) {
   if (tipo == 'nuevo') {
     timerOut(10).then((value: any) => {
       if (value) { this.selectTipoInventario.nativeElement.focus(); }
     })
   }
 }

 /*************METODOS TAB CLASES********************/
 gettabclases() {
   /*  this.articuloService.getClase(this.objarticulo.tipinv).subscribe((resp: any) => {
       console.log('el body')
       console.log(resp)
       console.log(resp.body);
     }, err => {
       console.log(err)
       basicAlert('Error al eliminar el registro.', 'error', 'Aceptar')
     }) */
 }

 EliminarClase(data: any) {
   console.log(data)
   alertaConfirmacion('¿Está seguro de eliminar el registro?', 'warning', false, true)
     .then((responseAlert) => {
       if (responseAlert != undefined && responseAlert != null && responseAlert) {
         this.spinnerService.activarLoading(true);
         console.log(this.clases)
         let arreglo = this.clases.filter(element => element != data);

         this.clases = arreglo
         console.log(this.clases)
         this.articuloService.delete_clase(this.objarticulo.tipinv, this.objarticulo.codart, data.clase).subscribe((response: any) => {
           console.log('delete_clase')
           this.spinnerService.activarLoading(false);
           basicAlert('Se eliminó correctamente.', 'success', 'Aceptar', null, null);

         }, err => {
           console.log('error delete_clase')
           this.spinnerService.activarLoading(false);
           console.log(err.error.mensaje);
           basicAlert(err.error, 'success', 'Aceptar');
         });

         this.clases = [...this.clases]

       }
     })
 }

 EliminarEAN(data: any) {
  console.log(data)
  alertaConfirmacion('¿Está seguro de eliminar el registro?', 'warning', false, true)
    .then((responseAlert) => {
      if (responseAlert != undefined && responseAlert != null && responseAlert) {
        this.spinnerService.activarLoading(true);
        this.articuloService.eliminarEan(this.objarticulo.tipinv, this.objarticulo.codart, data.item).subscribe((response: any) => {
          this.spinnerService.activarLoading(false);
          basicAlert('Se eliminó correctamente.', 'success', 'Aceptar', null, null);
          this.getlistaEANArticulos(this.objarticulo.tipinv, this.objarticulo.codart)

        }, err => {
          this.spinnerService.activarLoading(false);
          basicAlert(err.error, 'success', 'Aceptar');
        });
      }
    })
}
 EliminarClaseAlt(data: any) {
  alertaConfirmacion('¿Está seguro de eliminar el registro?', 'warning', false, true)
    .then((responseAlert) => {

      if (responseAlert != undefined && responseAlert != null && responseAlert) {
        this.spinnerService.activarLoading(true);
        let arreglo = this.clasesAlternativas.filter(element => element != data);

        this.articuloService.delete_clase_altern(this.objarticulo.tipinv, this.objarticulo.codart, data.clase, data.codigo).subscribe((response: any) => {
          console.log('delete_clase_alt')
          this.clasesAlternativas = arreglo
          this.spinnerService.activarLoading(false);
          this.clasesAlternativas = [...this.clasesAlternativas]
          basicAlert('Se eliminó correctamente.', 'success', 'Aceptar', null, null);

        }, err => {
          console.log('error delete_clase_alt')
          this.spinnerService.activarLoading(false);
          console.log(err.error.mensaje);
          basicAlert(err.error, 'success', 'Aceptar');
        });

      }
    })
}

 EliminarClaseGlobal(data: any) {
   alertaConfirmacion('¿Está seguro de eliminar el registro?', 'warning', false, true)
     .then((responseAlert) => {

       if (responseAlert != undefined && responseAlert != null && responseAlert) {
         this.spinnerService.activarLoading(true);
         let arreglo = this.clasesGlobales.filter(element => element != data);
         this.clasesGlobales = arreglo
         this.articuloService.delete_clase_global(this.objarticulo.tipinv, this.objarticulo.codart, data.clase).subscribe((response: any) => {
           console.log('delete_clase_global')
           this.spinnerService.activarLoading(false);
           basicAlert('Se eliminó correctamente.', 'success', 'Aceptar', null, null);

         }, err => {
           console.log('error delete_clase_global')
           this.spinnerService.activarLoading(false);
           console.log(err.error.mensaje);
           basicAlert(err.error, 'success', 'Aceptar');
         });

         this.clasesGlobales = [...this.clasesGlobales]
       }
     })
 }


 EliminarEspecificacion(data: any) {
   alertaConfirmacion('¿Está seguro de eliminar el registro?', 'warning', false, true)
     .then((responseAlert) => {

       if (responseAlert != undefined && responseAlert != null && responseAlert) {
         this.spinnerService.activarLoading(true);
         let arreglo = this.especificaciones.filter(element => element != data);
         this.especificaciones = arreglo
         this.articuloService.delete_especificacion(this.objarticulo.tipinv, this.objarticulo.codart, data.codesp).subscribe((response: any) => {
           console.log('delete_especificacion')
           this.spinnerService.activarLoading(false);
           basicAlert('Se eliminó correctamente.', 'success', 'Aceptar', null, null);
         }, err => {
           console.log('error delete_especificacion')
           this.spinnerService.activarLoading(false);
           console.log(err.error.mensaje);
           basicAlert(err.error, 'success', 'Aceptar');
         });
         this.especificaciones = [...this.especificaciones]
       }
     })
 }

 openNuevoClase(edtClase: string) {
   this.selectModalNuevo();
   this.newClase = true;
   this.objClaseCodigoDescripcion = new objClaseCodigoDescripcion();
   this.open(edtClase)
   this.disabcod = false;
   this.buscarcodCla = 'borrar';

  //  this.modalService.open(edtClase, {
  //    ariaLabelledBy: 'modal-basic-title',
  //    size: 'lg'
  //  }).result.then((result) => {
  //    this.closeResult = `closed with: ${result}`;
  //  }, (reason) => {
  //    this.closeResult = `dismissed ${this.getDismissReason(reason)}`;
  //  });
 }


 openUpdate(item: any, edtClase: any) {


   this.spinnerService.activarLoading(true)
   this.articuloService.getClase(this.objarticulo.tipinv).subscribe(response => {
     this.spinnerService.activarLoading(false)
     this.clasesSelect = response.body;

     this.newClase = false;
     this.objClaseCodigoDescripcion = item;

     this.spinnerService.activarLoading(true)
     this.articuloService.getClaseCodigo(this.objarticulo.tipinv, this.objClaseCodigoDescripcion.clase).subscribe((resp: any) => {
       this.spinnerService.activarLoading(false)
       this.clasesCodigos = resp.body;
       this.buscarcodCla = 'borrar';
       this.disabcod = true;
       this.open(edtClase)
     }, err => {
       this.spinnerService.activarLoading(false)
       console.log(err)
     })

   }, err => {
     this.spinnerService.activarLoading(false)
     basicAlert(err.error, 'warning', 'Aceptar');

   })
 }


 openUpdate2(item: any, edtClase: any) {


      this.spinnerService.activarLoading(true)
      this.spinnerService.activarLoading(false)
      this.objEAN = item;
      this.open(edtClase)

}

 openNuevoClaseAlternativa(content1: string) {
  console.log('abrir modal')
  this.selectModalNuevoClaseGlobal();
  this.objClaseAltenativa = {};

  // this.modalService.open(content1, { ariaLabelledBy: 'modal-basic-title', size: 'lg' }).result.then((result) => {

  //   this.closeResult = `Closed with: ${result}`;
  // }, (reason) => {
  //   this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
  // });

  this.open(content1)

}

 openNuevoClaseGlobal(content1: string) {
   console.log('abrir modal')
   this.selectModalNuevoClaseGlobal();
   this.objClaseGlobal = new objClaseCodigoDescripcion();

  //  this.modalService.open(content1, { ariaLabelledBy: 'modal-basic-title', size: 'lg' }).result.then((result) => {

  //    this.closeResult = `Closed with: ${result}`;
  //  }, (reason) => {
  //    this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
  //  });

   this.open(content1)

 }

 openNuevoClaseGlobalUNSPSC(content1: string) {
   console.log('abrir modalUNSPC')
   //  this.selectModalNuevoClaseGlobal();
   // this.objClaseGlobal = new objClaseCodigoDescripcion();

  //  this.modalService.open(content1, { ariaLabelledBy: 'modal-basic-title', size: 'lg' }).result.then((result) => {

  //    this.closeResult = `Closed with: ${result}`;
  //  }, (reason) => {
  //    this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
  //  });

   this.open(content1)

 }

 openNuevoEspecificacion() {
   console.log('abrir modal especificacion')
   this.mostrarModalTabEspecificion()
 }

 selectModalNuevo() {
   this.spinnerService.activarLoading(true)
   this.articuloService.getClase(this.objarticulo.tipinv).subscribe(response => {
     this.spinnerService.activarLoading(false)
     let clasestemp = response.body;
     if (this.clases != null) {
       this.clases.forEach(element => {
         clasestemp = clasestemp.filter(function (dato) {
           if (dato.codigo == element.clase) {
             return false;
           } else {
             return true;
           }
         });
       });
     }
     this.clasesSelect = clasestemp;
     this.objClaseCodigoDescripcion.clase = this.clasesSelect[0].codigo
     if (this.objClaseCodigoDescripcion.clase != null)
       this.onChangeNuevaClase(null, this.objClaseCodigoDescripcion.clase);

   })
 }

 selectModalEspecificacion() {

   // this.articuloService.listEspecificaciones(this.objarticulo.tipinv).subscribe(response => {
   this.articuloService.listEspecificaciones(this.objarticulo.tipinv).subscribe(response => {
     let clasestemp = response.body;
     if (this.especificaciones != null) {
       this.especificaciones.forEach(element => {
         clasestemp = clasestemp.filter(function (dato) {
           if (dato.codigo == element.codesp) {
             //console.log("SI existe")
             return false;
           } else {
             //   console.log("SI existe")
             return true;
           }
         });
       });
     }
     console.log('arreglo select especificacion:')
     console.log(clasestemp)
     this.clasesSelectEspecificaciones = clasestemp;

   })
 }

 selectModalNuevoClaseGlobal() {
   console.log('select clases globales')
   this.articuloService.getClasesGlobal().subscribe(response => {
     console.log(response)
     let clasesglobalestemp = response.body;
     if (this.clasesGlobales != null) {
       this.clasesGlobales.forEach(element => {
         clasesglobalestemp = clasesglobalestemp.filter(function (dato) {
           if (dato.codigo == element.clase) {
             //   console.log("SI existe")
             return false;
           } else {
             //    console.log("SI existe")
             return true;
           }
         });
       });
     }
     console.log('ARREGLO FINAL SELECT GLOBAL:')
     this.clasesGlobalesSelect = clasesglobalestemp;
     this.objClaseGlobal.clase = this.clasesGlobalesSelect[0].codigo
     if (this.objClaseGlobal.clase != null)
       this.onChangeNuevaClaseGlobal(null, this.objClaseGlobal.clase);

   })
 }

 onChangeNuevaClase($event, clase: number) {
   console.log('modifica select clase')
   this.getCodigoClase(1, this.objarticulo.tipinv, clase);
 }

 onChangeNuevaClaseGlobal($event, clase: number) {
   console.log('modifica select clase Global')
   this.getCodigoClaseGlobal(1, clase);
 }

 getCodigoClase(accion: number, tipinv: number, clase: number) {
   this.spinnerService.activarLoading(true)
   this.articuloService.getClaseCodigo(tipinv, clase).subscribe((resp: any) => {
     this.spinnerService.activarLoading(false)
     console.log(resp.body);
     this.clasesCodigos = resp.body;
     console.log('MOdal select')
     console.log(this.clasesCodigos)
     if (accion == 1) {
       this.objClaseCodigoDescripcion.codigo = this.clasesCodigos[0].codigo
     } else {
       if (this._codigo != null)
         this.objClaseCodigoDescripcion.codigo = this._codigo;
     }
   }, err => {
     this.spinnerService.activarLoading(false)
     console.log(err)
   })
 }

 getCodigoClaseGlobal(accion: number, clase: number) {
   this.spinnerService.activarLoading(true)
   this.articuloService.getClaseCodigoGlobal(clase, '', '', '').subscribe((resp: any) => {
     this.spinnerService.activarLoading(false)
     console.log(resp);
     this.clasesCodigosGlobal = resp.body;
     console.log('MOdal select clase global')
     console.log(this.clasesCodigosGlobal)
     if (accion == 1) {
       this.objClaseGlobal.codigo = this.clasesCodigosGlobal[0].codigo
     } else {
       if (this._codigoglobal != null)
         this.objClaseGlobal.codigo = this._codigoglobal;
     }
   }, err => {
     this.spinnerService.activarLoading(false)
     console.log(err)
   })

 }

 closeInsertclass() {
   this.objClaseCodigoDescripcion = new objClaseCodigoDescripcion()
 }
 closeInsertEspecificacion() {
   this.objClaseCodigoEspecifi = new objArticuloEspecificacion()
 }

 closeInsertclassGlobal() {
   this.objClaseGlobal = new objClaseCodigoDescripcion()
 }

 closeInsertclassGlobalUNSPSC() { }

 guardarClase() {
   console.log(this.objClaseCodigoDescripcion)
   if (this.objClaseCodigoDescripcion.clase != null && this.objClaseCodigoDescripcion.codigo != null) {

     if (this.clasesSelect != null)
       this.clasesSelect.forEach(element => {
         console.log('entro al foreach')
         if (element.codigo == this.objClaseCodigoDescripcion.clase) {
           this.objClaseCodigoDescripcion.desclase = element.descri
         }
       });
     if (this.clasesCodigos != null)
       this.clasesCodigos.forEach(element => {
         if (element.codigo == this.objClaseCodigoDescripcion.codigo) {
           this.objClaseCodigoDescripcion.descodigo = element.descri
         }
       });

     if (this.clases != null)
       if (this.clases.find(x => x.clase == this.objClaseCodigoDescripcion.clase) == null) {
         this.clases.push(this.objClaseCodigoDescripcion)
         this.clases = [...this.clases]
         this.objClaseCodigoDescripcion = new objClaseCodigoDescripcion()
         this.modal.close();
        } else {
         basicAlert('El código de clase ya existe.', 'warning', 'Aceptar', null, null);
         this.objClaseCodigoDescripcion = new objClaseCodigoDescripcion()
         return;
       }

   } else {
     //En caso no se llenen los datos necesarios
     var dato = ''
     if (this.objClaseCodigoDescripcion.clase == null) {
       dato = '"Clase"'
     } else if (this.objClaseCodigoDescripcion.codigo == null) {
       dato = '"Código"'
     }
     basicAlert("El campo " + dato + "es obligatorio.", 'warning', 'Aceptar');

   }
 }

  guardarEAN() {
    console.log(this.objEAN)
    if (this.objEAN.ean != null) {
      // if (this.listean != null)
      //   if (this.listean.find(x => x.item == this.objEAN.item) == null) {
          this.objEAN.tipinv = this.objarticulo.tipinv
          this.objEAN.codart = this.objarticulo.codart

          this.spinnerService.activarLoading(true)
          this.articuloService.insertarEan(this.objEAN).subscribe((resp: any) => {
            this.spinnerService.activarLoading(false)
            this.toastr.success('Se agregó correctamente.','',{ positionClass: 'toast-bottom-left'});
            this.getlistaEANArticulos(this.objarticulo.tipinv, this.objarticulo.codart)
            this.objEAN = {}
            this.modal.close();
            
          }, err => {
            this.spinnerService.activarLoading(false)
            basicAlert('No se puede ingresar EAN.', 'warning', 'Aceptar', null, null);
          })

        // } else {
        //   basicAlert('El código de item ya existe.', 'warning', 'Aceptar', null, null);
        //   this.objEAN = {}
        //   return;
        // }
    } else {
      //En caso no se llenen los datos necesarios
      var dato = ''
      if (this.objEAN.item == null) {
        dato = '"Item"'
      } else if (this.objEAN.ean == null) {
        dato = '"EAN"'
      }
      basicAlert("El campo " + dato + "es obligatorio.", 'warning', 'Aceptar');
    }
  }

  edtarEAN() {
    //POR SERVICIO
    this.spinnerService.activarLoading(true)
    this.articuloService.modificarEan(this.objEAN).subscribe((resp: any) => {
      this.spinnerService.activarLoading(false)
      console.log(resp);
      this.toastr.success('Se modificó correctamente.','',{ positionClass: 'toast-bottom-left'});

      this.getlistaEANArticulos(this.objarticulo.tipinv, this.objarticulo.codart)

      // this.listean.push(this.objEAN)
      // this.listean = [...this.listean]
      this.objEAN = {}
      this.modal.close();
      
    }, err => {
      this.spinnerService.activarLoading(false)
      basicAlert('No se puede ingresar EAN.', 'warning', 'Aceptar', null, null);
    })

  }

 edtarClase() {

   this.clases.forEach(element => {
     if (element.clase == this.objClaseCodigoDescripcion.clase) {
       element.codigo = this.objClaseCodigoDescripcion.codigo;

       if (this.clasesCodigos != null)
         this.clasesCodigos.forEach(element2 => {
           if (element2.codigo == this.objClaseCodigoDescripcion.codigo) {
             element.descodigo = element2.descri
           }
         });

         this.modal.close();
        }

   });

 }


 guardarClaseGlobal() {
   console.log(this.objClaseGlobal)
   if (this.objClaseGlobal.clase != null && this.objClaseGlobal.codigo != null) {
     console.log('entro al foreach clasesselect')
     console.log(this.clasesGlobalesSelect)
     this.clasesGlobalesSelect.forEach(element => {
       console.log('entro al foreach')
       if (element.codigo == this.objClaseGlobal.clase) {
         this.objClaseGlobal.desclase = element.descri
       }
     });
     console.log(this.clasesCodigosGlobal)
     this.clasesCodigosGlobal.forEach(element => {
       if (element.codigo == this.objClaseGlobal.codigo) {
         this.objClaseGlobal.descodigo = element.descri
       }
     });
     this.spinnerService.activarLoading(true);
     if (this.clasesGlobales.find(x => x.clase == this.objClaseGlobal.clase) == null) {
       //  basicAlert('Se registró correctamente', 'success', 'Aceptar', null, null,);
       this.spinnerService.activarLoading(false);
       console.log('Se agrega esto')
       console.log(this.objClaseGlobal)
       console.log(this.clasesGlobales)
       this.clasesGlobales.push(this.objClaseGlobal)
       this.clasesGlobales = [...this.clasesGlobales]
       this.objClaseGlobal = new objClaseCodigoDescripcion()
       this.modalService.dismissAll();
     } else {
       basicAlert('El código de clase ya existe.', 'warning', 'Aceptar', null, null);
       this.objClaseGlobal = new objClaseCodigoDescripcion()
       return;
     }
   } else {
     //En caso no se llenen los datos necesarios
     var dato = ''
     if (this.objClaseGlobal.clase == null) {
       dato = '"Clase"'
     } else if (this.objClaseGlobal.codigo == null) {
       dato = '"Código"'
     }
     basicAlert("El campo " + dato + "es obligatorio.", 'warning', 'Aceptar');

   }
 }

 guardarClaseGlobalUNSPSC() { }

 guardarEspecificacion() {
   this.spinnerService.activarLoading(true);
   this.objClaseCodigoEspecifi = new objArticuloEspecificacion()

   if (this.disabledCaracter == true) {
     console.log(this.caracter)
     if (this.caracter == null || this.caracter == '') {
       this.spinnerService.activarLoading(false);
       basicAlert('El campo caracter es requerido.', 'warning', 'Aceptar', null, null);
       return

     } else {
       this.objClaseCodigoEspecifi.vchar = this.caracter
     }
   }

   if (this.disabledFecha == true) {
     if (this.fecha == null || this.fecha == '') {
       this.spinnerService.activarLoading(false);
       basicAlert('El campo fecha es requerido.', 'warning', 'Aceptar', null, null);
       return

     } else {
       this.objClaseCodigoEspecifi.vdate = this.fecha
     }
   }

   if (this.disabledTexto == true) {
     console.log(this.texto)
     if (this.texto == null || this.texto == '') {
       this.spinnerService.activarLoading(false);
       basicAlert('El campo texto es requerido.', 'warning', 'Aceptar', null, null);
       return

     } else {
       this.objClaseCodigoEspecifi.vstrg = this.texto
     }
   }
   if (this.disabledTiempo == true) {
     if (this.tiempo == null || this.tiempo == '') {
       this.spinnerService.activarLoading(false);
       basicAlert('El campo tiempo es requerido.', 'warning', 'Aceptar', null, null);
       return

     } else {
       this.objClaseCodigoEspecifi.vtime = this.tiempo
     }
   }
   if (this.disabledDecimal == true) {
     console.log('el decimal: ' + this.decimal)
     if (this.decimal == null || this.decimal == '') {
       this.spinnerService.activarLoading(false);
       basicAlert('El campo decimal es requerido.', 'warning', 'Aceptar', null, null);
       return

     } else {
       this.objClaseCodigoEspecifi.vreal = this.decimal
     }
   }

   if (this.disabledNumero == true) {
     console.log(this.numero)
     if (this.numero == null || this.numero == '') {
       this.spinnerService.activarLoading(false);
       basicAlert('El campo numero es requerido.', 'success', 'Aceptar', null, null);
       return

     } else {
       this.objClaseCodigoEspecifi.ventero = this.numero
     }
   }
   //basicAlert('Se regisro de manera correcta.', 'success', 'Aceptar', null, null);
   this.objClaseCodigoEspecifi.codesp = this._especificacion
   this.objClaseCodigoEspecifi.descri = this._descriespecificacion
   console.log('se inserta al arreglo especificaciones:')
   console.log(this.objClaseCodigoEspecifi)
   this.especificaciones.push(this.objClaseCodigoEspecifi)
   this.especificaciones = [...this.especificaciones]
   console.log(this.especificaciones)
   //this.modalService.dismissAll(); cambiado a :
   this.modal.close();
   this.selectModalEspecificacion();
   this.spinnerService.activarLoading(false);
 }

 openModificarClase(content: string, clase: any) {
   console.log('modificar Clase')
   console.log(clase)
   this._codigo = clase.codigo;
   this.getCodigoClase(2, this.objarticulo.tipinv, clase.clase);
   //this.objClaseCodigoDescripcion.codigo = 
   this.objClaseCodigoDescripcion.clase = clase.clase
   // this.objClaseCodigoDescripcion.codigo = clase.codigo;

   this.objClaseCodigoDescripcion.desclase = clase.desclase;
   this.objClaseCodigoDescripcion.descodigo = clase.descodigo;
   this.editclase = clase
  //  this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'lg' }).result.then((result) => {
  //    this.closeResult = `Closed with: ${result}`;
  //  }, (reason) => {
  //    this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
  //  });

   this.open(content)

 }

 openModificarClaseGlobal(content: string, clase: any) {
   console.log('modificar Clase Global')
   console.log(clase)
   this._codigoglobal = clase.codigo;
   this.getCodigoClaseGlobal(2, clase.clase);
   //this.objClaseCodigoDescripcion.codigo = 
   this.objClaseGlobal.clase = clase.clase
   // this.objClaseCodigoDescripcion.codigo = clase.codigo;

   this.objClaseGlobal.desclase = clase.desclase;
   this.objClaseGlobal.descodigo = clase.descodigo;
   this.editclaseGlobal = clase
  //  this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'lg' }).result.then((result) => {
  //    this.closeResult = `Closed with: ${result}`;
  //  }, (reason) => {
  //    this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
  //  });

   this.open(content)

 }

 openModificarEspecificacion(content: string, clase: any) {
   this.disabledDecimal = true;
   this.disabledTexto = true;
   this.disabledCaracter = true;
   this.disabledFecha = true
   this.disabledTiempo = true;
   this.disabledNumero = true;

   console.log((clase))
   this.objClaseCodigoEspecifi = clase

   if (clase.vreal == null) {
     this.disabledDecimal = false;
   }
   if (clase.vstrg == null) {
     this.disabledTexto = false;
   }
   if (clase.vchar == null) {
     this.disabledCaracter = false;
   }
   if (clase.vdate == null) {
     this.disabledFecha = false;
   }
   if (clase.vtime == null) {
     this.disabledTiempo = false;
   }
   if (clase.ventero == null) {
     this.disabledNumero = false;
   }

   this._especificacion = clase.codesp
   this._descriespecificacion = clase.descri

   this.editespecificacion = clase
   console.log(this.editespecificacion)
   this.open(content)
  //  this.modal = this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'lg' }).result.then((result) => {
  //    this.closeResult = `Closed with: ${result}`;
  //  }, (reason) => {
  //    this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
  //  });
 }

 open(content) {
  this.modal = this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'lg'})    
  this.modal.result.then((e) => {
      console.log("dialogo cerrado")
  });        
}
 //Actualizar Clase
 guardarActualizarClase() {
   console.log('clase a editar')
   this.clasesCodigos.forEach(element => {
     if (element.codigo == this.objClaseCodigoDescripcion.codigo) {
       this.objClaseCodigoDescripcion.descodigo = element.descri
     }
   });
   let arreglo = this.clases;
   let indice = arreglo.indexOf(this.editclase)
   console.log(indice)
   arreglo[indice] = this.objClaseCodigoDescripcion;

   this.clases = arreglo
   this.clases = [...this.clases]
   basicAlert('Se actualizó con éxito.', 'success', 'Aceptar', null, null);
   //this.modalService.dismissAll();
   console.log('Asi quedo el arreglo clase')
   console.log(this.clases)
 }

 guardarActualizarEspecificacion() {

   console.log('clase a editar')
   /*   this.clasesCodigos.forEach(element => {
        if (element.codigo == this.objClaseCodigoDescripcion.codigo) {
          this.objClaseCodigoDescripcion.descodigo = element.descri
        }
      });*/
   let arreglo = this.especificaciones;
   let indice = arreglo.indexOf(this.editespecificacion)
   console.log(indice)
   arreglo[indice] = this.objClaseCodigoEspecifi;

   this.especificaciones = arreglo
   this.especificaciones = [...this.especificaciones]
   basicAlert('Se actualizó con éxito.', 'success', 'Aceptar', null, null);
  //  this.modalService2.close();
  this.modal.close();
  console.log('Asi quedo el arreglo clase')
   console.log(this.especificaciones)

 }

 guardarActualizarClaseGlobal() {
   console.log('clase a editar')
   this.clasesCodigosGlobal.forEach(element => {
     if (element.codigo == this.objClaseGlobal.codigo) {
       this.objClaseGlobal.descodigo = element.descri
     }
   });
   let arreglo = this.clasesGlobales;
   let indice = arreglo.indexOf(this.editclaseGlobal)
   console.log(indice)
   arreglo[indice] = this.objClaseGlobal;

   this.clasesGlobales = arreglo
   this.clasesGlobales = [...this.clasesGlobales]
   basicAlert('Se actualizó con éxito.', 'success', 'Aceptar', null, null);
   this.modalService2.close();
   console.log('Asi quedo el arreglo clase')
   console.log(this.clases)
 }

 /*************************************************/

 //METODOS TAB LISTA PRECIOS 

 getlistaPrecioArticulos(tipinv: number, codart: string) {
   this.articuloService.listPrecios(tipinv, codart).subscribe((resp: any) => {

     console.log('La lista de precios es: ...');
     console.log(resp.body);
     this.listaPreciosArticulo = resp.body.list;
   }, err => {

   })
 }

 getlistaEANArticulos(tipinv: number, codart: string) {
  this.articuloService.listEan(tipinv, codart).subscribe((resp: any) => {
    console.log('La lista de EAN es: ...');
    console.log(resp.body);
    this.listean = resp.body;
  }, err => {

  })
}
 //METODOS TAB CLASES GLOBALES

 getlistaClasesGlobales() {
   this.articuloService.getClasesGlobal().subscribe((resp: any) => {
     console.log('La lista de clases globales es: ...');
     console.log(resp.body);
     this.clasesAlternativasSelect = resp.body //clasesGlobalesSelect
   }, err => {
   })
 }

 getlistaClasesAlternativas() {
  this.articuloService.getClasesAlternativa('').subscribe((resp: any) => {
    console.log('La lista de clases alter es: ...');
    console.log(resp.body);
    this.clasesAlternativasSelect = resp.body
  }, err => {
  })
}
 //METODOS TAB CLASES IMAGENES

 getImagen(tipinv: number, codart: string, codigo: number, cia: string) {
   this.articuloService.obtenerImagenArticulo(tipinv, codart, codigo, cia).subscribe((resp: any) => {
     console.log('OBTENER IMAGEN : ...');
     console.log(resp.body);
   }, err => {
   })
 }
 obtenerCodigoImagen(linkImagen: string): string {
  if (!linkImagen) {
    console.error("Error: El enlace de imagen está vacío.");
    return '';
  }

  console.log("Link recibido:", linkImagen);

  const splitted = linkImagen.split('/');
  console.log("Resultado del primer split:", splitted);

  if (splitted.length < 12) {
    console.error("Error: La estructura del enlace de imagen es incorrecta. Se esperaba al menos 12 segmentos, pero se obtuvieron:", splitted.length);
    return '';
  }

  const segmentWithCode = splitted[11];
  console.log("Segmento que debería contener el código:", segmentWithCode);

  const splitted2 = segmentWithCode.split("?");
  console.log("Resultado del segundo split (por ?):", splitted2);

  if (!splitted2 || splitted2.length === 0) {
    console.error("Error: No se pudo obtener el código de la imagen del enlace. El segundo split no produjo resultados válidos.");
    return '';
  }

  const codigoImagenReal = splitted2[0];
  console.log("Código de imagen extraído:", codigoImagenReal);

  return codigoImagenReal;
}

getListImage() {
  this.spinnerService.activarLoading(true);
  this.articuloService.listaArticuloImagenes(this.codTipoInventario, this.objarticulo.codart).subscribe({
    next: (res) => {
      this.arregloPrueba = res.body.map(url => `${url}&t=${new Date().getTime()}`);
      this.spinnerService.activarLoading(false);
    },
    error: (err) => {
      console.error('Error al obtener la lista de imágenes:', err);
      this.spinnerService.activarLoading(false);
    }
  });
}
 
agregarImagen() {   
  this.spinnerService.activarLoading(true);
  this.articuloService.insertarImagenArticulo(this.codTipoInventario, this.objarticulo.codart, this.objImagen)
    .subscribe({
      next: () => {
        basicAlert('Se registró correctamente.', 'success', 'Aceptar', null, null, null);
        this.fileUpload.nativeElement.value = ""; 
        this.disabledbotonImagen = true;
        this.sinImagenAdjunto();  
        this.arregloPrueba = [];
        this.getListImage();
        this.spinnerService.activarLoading(false);
      },
      error: (err) => {
        console.error("Error al intentar agregar la imagen:", err);
      }
    });
}
uploadImage(event:any) {
  var file: File = event.target.files[0];
  var myReader: FileReader = new FileReader();
  this.formato = file.type;
  this.size = file.size;
  const fileSizeInMB = this.size / (1024 * 1024);
  const fileName = file.name.toLowerCase();
  if (fileSizeInMB<=1) {
    if (file.type === 'image/jpeg' && fileName.endsWith('.jpg')) {
       myReader.onloadend = (e) => {
        const imageBase64 = myReader.result as string;
        this.imagenAdjunto = this._sanitizer.bypassSecurityTrustResourceUrl(imageBase64);
        this.objImagen.imagen = imageBase64.replace("data:image/jpeg;base64,", "");
        this.objImagen.formato = 'jpg';
        this.agregarImagen();

      }  
      myReader.readAsDataURL(file);
      this.disabledbotonImagen = false;
    }
    else {
      basicAlert('Debe seleccionar una imagen con formato .JPG.', 'warning', 'Aceptar', null, null, null);
      this.disabledbotonImagen = true;
      this.fileUpload.nativeElement.value = "";
      return;
    }
  } else {
    basicAlert('El tamaño de la imagen excedio el limite permitido de 1Mb.', 'warning', 'Aceptar', null, null, null);
    this.disabledbotonImagen = true;
    this.fileUpload.nativeElement.value = "";
    return;
  }
}

deleteImagen(index: number) {
  alertaConfirmacion('¿Está seguro de eliminar el registro?', 'warning', false, true)
  .then((responseAlert) => {
    if (responseAlert) {
  this.spinnerService.activarLoading(true);
  const imagenSeleccionada = this.arregloPrueba[index];
  console.log("Imagen seleccionada para eliminar:", imagenSeleccionada);
  console.log("Índice de imagen en la lista:", index);

  if (!imagenSeleccionada) {
    console.error("Error: No se encontró la imagen en la lista.");
    return;
  }

  const codigoImagen = this.obtenerCodigoImagen(imagenSeleccionada);
  if (!codigoImagen) {
    console.error("Código de imagen inválido o no encontrado.");
    return;
  }

  this.articuloService.deleteImagenArticulo(this.codTipoInventario, this.objarticulo.codart, codigoImagen)
    .subscribe({
      next: () => {
        basicAlert('Se eliminó correctamente.', 'success', 'Aceptar', null, null, null);
        this.arregloPrueba = [];
        this.getListImage();
        this.sinImagenAdjunto();
        this.spinnerService.activarLoading(false);
      },
      error: (err) => {
        if (err.status == 404) {
          console.log(err);
            basicAlert('Servicio no disponible.', 'warning', 'Aceptar', null, null, null);
            this.spinnerService.activarLoading(false);
        }
      }
    });
  }
});
}

sinImagenAdjunto() {
 this.imagenAdjunto = 'assets/img/noimage.png';
}

 agregarAdjunto() {
  this.objAdjunto.imagen = this.image;
  this.objAdjunto.formato = 'jpg';

  console.log(this.objAdjunto);
  //this.funicionesTSIService.activarLoading(true);
  this.spinnerService.activarLoading(true);
  //  this.articulosService.insertImagen(this.codTipoInventario, this.objArticulo.codArticulo, this.objImagen).subscribe((response: any) => {
  this.articuloService.insertarImagenArticulo(this.codTipoInventario, this.objarticulo.codart, this.objImagen).subscribe((response: any) => {
    console.log(response);
    this.fileUpload.nativeElement.value = "";
    this.disabledbotonImagen = true;
    setTimeout(() => {
      this.getListImage();
    }, 150);
    // this.funicionesTSIService.activarLoading(false);
    this.spinnerService.activarLoading(false);
  }, err => {
    if (err.status == 404) {
      console.log(err);
      //this.funicionesTSIService.alertSweet('Servicio no disponible', 'warning');
      basicAlert('Servicio no disponible.', 'warning', 'Aceptar', null, null, null);
      // this.funicionesTSIService.activarLoading(false);
      this.spinnerService.activarLoading(false);
    }
  })
}

 
 uploadAdjunto($event): void {
  this.readThisAdjunto($event.target);
}

 public base64convertido: any;
 nombrearchivo

 readThisAdjunto(inputValue: any): void {
  let imageBase64;
  var file: File = inputValue;
  var myReader: FileReader = new FileReader();

  console.log(file);
  myReader.onloadend = (e) => {
    imageBase64 = myReader.result;
    this.base64convertido = imageBase64.replace("data:"+file.type+";base64,", "");
      this.formato = file.type;
      this.size = file.size;
      this.nombrearchivo = file.name;
       
        this.disabledbotonImagen = false;
  
          let obj: any = {
            tipinv: this.tipinv, //tipinv
            codart: this.codart,
            base64: this.base64convertido,
            formato: this.formato,
            nombre: this.nombrearchivo,
          }
          console.log("insertando obj:")
          console.log(obj)
          this.agregarAdjunto1(obj);
  }
  myReader.readAsDataURL(file);

  // this.formato = file.type;
  // this.size = file.size;

  // if (this.size <= (2 * 1048576)) {
    // if (file.type == 'image/jpeg') {
    //   myReader.onloadend = (e) => {
    //     imageBase64 = myReader.result;
    //     console.log(imageBase64);
    //     this.image = imageBase64.replace("data:image/jpeg;base64,", "");
    //   }
    //   myReader.readAsDataURL(file);
    //   this.disabledbotonImagen = false;
    // }
    // else {
    //   //this.funicionesTSIService.alertSweet('Debe seleccionar una imagen con formato .JPG', 'warning');
    //   basicAlert('Debe seleccionar una imagen con formato .JPG.', 'warning', 'Aceptar', null, null, null);
    //   this.disabledbotonImagen = true;
    //   this.fileUpload.nativeElement.value = "";
    //   return;
    // }
  // } else {
  //   // this.funicionesTSIService.alertSweet('El tamaño de la imagen excedio el limite permitido de 1Mb', 'warning');
  //   basicAlert('El tamaño de la imagen excedio el limite permitido de 2Mb.', 'warning', 'Aceptar', null, null, null);
  //   this.disabledbotonImagen = true;
  //   this.fileUpload.nativeElement.value = "";
  //   return;
  // }
}
onInputClick(e) {
  e.target.value = '';
}

Numarchivos: number = 0
fileToUpload: FileList = null;
fileName: string = '';
handleFileInput(files: FileList) {
  this.spinnerService.activarLoading(true);
  console.log("cantidad de archivos")
  console.log(files.length)
  console.log(files)
  this.fileToUpload = files;
  this.fileName = files.item(0).name;

  for (let i = 0; i < files.length; i++) {
    console.log("loop")
    console.log(files.item(i))
    this.readThisAdjunto(files.item(i))
  }
  this.spinnerService.activarLoading(false);
}

getAdjuntos(){
  //FALTA CORREGIR
  console.log("obteniendo adjuntos")

  this.spinnerService.activarLoading(true);
  this.articuloService.obtenerAdjuntoArticulo(this.tipinv, this.codart).subscribe((response: any) => {
    console.log(response); 
    this.doc_adjuntos = response.body.map(objeto => ({
      ...objeto, // Copiamos todas las propiedades originales
      obs: objeto.observ // Agregamos el nuevo campo
    }));
    this.spinnerService.activarLoading(false);
  }, err => {
    if (err.status == 404) {
      this.spinnerService.activarLoading(false);
      console.log(err);
      this.doc_adjuntos = [];
      // basicAlert('Servicio no disponible.', 'warning', 'Aceptar', null, null, null);
    }
  })
}

agregarAdjunto1(obj) {
  this.spinnerService.activarLoading(true);
  this.articuloService.insertarAdjuntoArticulo(obj).subscribe((response: any) => {
    this.getAdjuntos();
    this.spinnerService.activarLoading(false);
  }, err => {
    if (err.status == 404) {
      console.log(err);
      this.spinnerService.activarLoading(false);
      basicAlert('Servicio no disponible.', 'warning', 'Aceptar', null, null, null);
    }
    else
    this.spinnerService.activarLoading(false);
    basicAlert(err.error, 'warning', 'Aceptar', null, null, null);
  })
}

eliminarAdj(data){
  this.spinnerService.activarLoading(true);
  this.articuloService.deleteAdjuntoArticulo(this.tipinv, this.codart,data.id).subscribe((response: any) => {
    this.spinnerService.activarLoading(false);
    console.log("-------- ADJUNTOS ------");
    console.log(response)
    this.getAdjuntos();
    this.toastr.success('Se eliminó correctamente.','',{ positionClass: 'toast-bottom-left'});
  }, err => {
    basicAlert(`Error`, 'warning', 'Aceptar');
    this.spinnerService.activarLoading(false);
  });

}

descargarAdj(data){
  this.spinnerService.activarLoading(true);
  this.articuloService.descargarAdjuntoArticulo(this.tipinv, this.codart,data.id).subscribe((response: any) => {
    this.spinnerService.activarLoading(false);
    console.log(response); 

    if (response.byteLength > 0) {
      // let file = new Blob([response], { type: 'application/vnd.ms-excel' });
      let file = new Blob([response], { type: data.formato });

      var fileURL = URL.createObjectURL(file);
      FileSaver.saveAs(fileURL, data.nombre);
    } else {
      basicAlert('No hay resultados', 'warning', 'Aceptar', null, null, null);
    }

  }, err => {
    if (err.status == 404) {
      this.spinnerService.activarLoading(false);
      console.log(err);
      basicAlert('Servicio no disponible.', 'warning', 'Aceptar', null, null, null);
    }
  })
}
 /**************************** */

 private getDismissReason(reason: any): string {
   if (reason === 1) {
     return 'by pressing ESC';
   } else if (reason === 0) {
     return 'by clicking on a backdrop';
   } else {
     return `with: ${reason}`;
   }
 }
 tipoglosa=1;
 glosacotizaciones
 glosafacturacion
 glosapresupuestos
 glosa
 tipo

 guardarGlosa(){
   let swdefault
   if (this.predeterminadoUpd == true) {
     swdefault = 'S';
   } else {
     swdefault = 'N';
   }

   let glosaData: any = {
    
     tipinv: this.objarticulo.tipinv,
     tipo: this.tipoglosa,
     codart: this.objarticulo.codart,
     // glosacotizaciones: this.glosacotizaciones,
     // glosafacturacion: this.glosafacturacion,
     // glosapresupuestos: this.glosapresupuestos,
     observ: this.glosa,
     swdefaul : swdefault,
   }

  //  if(this.tipo == 'Nuevo'){
  //    this.spinnerService.activarLoading(true);
  //    this.articuloService.insertarGlosa(glosaData).subscribe((resp: any) => {
  //      this.spinnerService.activarLoading(false);
  //      console.log(resp.body);
  //      this.toastr.success('Se actualizó correctamente.')
 
  //    }, err => {
  //      this.spinnerService.activarLoading(false);
  //      basicAlert(err.message, 'warning', 'Aceptar', null, null, this.desarticulo)
  //    })
  //  }
  //  else{
     this.spinnerService.activarLoading(true);
     this.articuloService.modificarGlosa(glosaData).subscribe((resp: any) => {
       this.spinnerService.activarLoading(false);
       console.log(resp.body);
       this.toastr.success('Se actualizó correctamente.','',{ positionClass: 'toast-bottom-left'})
 
     }, err => {
       this.spinnerService.activarLoading(false);
       basicAlert(err.message, 'warning', 'Aceptar', null, null, this.desarticulo)
     })
  //  }

 }

 eliminarGlosas(){
   this.spinnerService.activarLoading(true);
   this.articuloService.eliminarGlosa(this.objarticulo.tipinv , this.objarticulo.codart,this.tipoglosa).subscribe((resp: any) => {
     this.spinnerService.activarLoading(false);
     console.log(resp.body);
     this.toastr.success('Se actualizó correctamente.','',{ positionClass: 'toast-bottom-left'})
   }, err => {
     this.spinnerService.activarLoading(false);
     basicAlert(err.message, 'warning', 'Aceptar', null, null, this.desarticulo)
   })
 }

 public predeterminadoUpd: boolean;

 onChangePredeterminadoUpd(isChecked: boolean) {
   if (isChecked) {
     this.predeterminadoUpd = true;
   } else {
     this.predeterminadoUpd = false;
   }
 }

 public getGlosa() {
   this.glosa = '' ,
   this.predeterminadoUpd = false

   this.spinnerService.activarLoading(true);
   this.articuloService.obtenerGlosa(this.objarticulo.tipinv , this.objarticulo.codart,this.tipoglosa).subscribe((response: any) => {
     this.spinnerService.activarLoading(false);
     console.log(response);
     this.tipo = 'Modificar'
     this.tipoglosa = response.body.tipo;
     this.glosa = response.body.observ;
     
     if(response.body.swdefaul == 'S'){
       this.predeterminadoUpd = true;
     }
     else{
       this.predeterminadoUpd = false;
     }

   }, err => {
     // basicAlert(`No hay glosas`, 'warning', 'Aceptar');
     this.tipo = 'Nuevo'
     this.spinnerService.activarLoading(false);
   });
 }
 cerrar(){
  this.modalService2.close(this.actualizarLista);
}

guardarClaseAlternativa() {
  console.log(this.objClaseAltenativa)
  if (this.objClaseAltenativa.clase != null && this.objClaseAltenativa.codigo != null) {
    this.clasesGlobalesSelect.forEach(element => {
      if (element.codigo == this.objClaseAltenativa.clase) {
        this.objClaseAltenativa.desclase = element.descri
      }
    });
    this.clasesCodigosGlobal.forEach(element => {
      if (element.codigo == this.objClaseAltenativa.codigo) {
        this.objClaseAltenativa.descodigo = element.descri
      }
    });
    this.spinnerService.activarLoading(true);
    if (this.clasesAlternativas.find(x => x.clase == this.objClaseAltenativa.clase) == null) {
      this.spinnerService.activarLoading(false);
      this.clasesAlternativas.push(this.objClaseAltenativa)
      this.clasesAlternativas= [...this.clasesAlternativas]
      this.objClaseAltenativa = {}
      this.modalService.dismissAll();
    } else {
      basicAlert('El código de clase ya existe.', 'warning', 'Aceptar', null, null);
      this.objClaseAltenativa = {}
      return;
    }
  } else {
    //En caso no se llenen los datos necesarios
    var dato = ''
    if (this.objClaseAltenativa.clase == null) {
      dato = '"Clase"'
    } else if (this.objClaseAltenativa.codigo == null) {
      dato = '"Código"'
    }
    basicAlert("El campo " + dato + "es obligatorio.", 'warning', 'Aceptar');

  }
}

disabledCodigo: boolean = true;
disabledReal: boolean = true;
disabledString: boolean = true;
disabledCaracter2: boolean = true;
public disabledBotonClases: boolean = true

onBlurClases(clase: number) {
  console.log("pasando onblur");
  console.log(clase);
  if (clase == 5 || clase == 7 || clase == 11 || clase == 12 || clase == 13 || clase == 15 || clase == 17 || clase == 18 || clase == 19 || clase == 50) {
    this.disabledString = false;

    this.disabledReal = true;
    this.disabledCodigo = true;
    this.disabledCaracter2 = true;

    setTimeout(() => {
      $('#codCodigoClase').focus();
    }, 150);
  } else if (clase == 8 || clase == 9 || clase == 16 || clase == 65) {
    this.disabledCaracter2 = false;

    this.disabledString = true;
    this.disabledReal = true;
    this.disabledCodigo = true;

    setTimeout(() => {
      $('#vChar').focus();
    }, 150);
  } else if (clase == 10 || clase == 25 ) {
    this.disabledCodigo = false;

    this.disabledReal = true;
    this.disabledString = true;
    this.disabledCaracter2 = true;

    setTimeout(() => {
      $('#codCodigoClase').focus();
    }, 150);
  }

  this.disabledBotonClases = false;
}

  onBlurSelectClases(data){
    console.log(data)

    this.clasesAlternativasSelect.forEach(element => {
      if (element.clase == data) {
        console.log(element)
        if(element.vchar != 'S'){
          this.disabledCaracter = true;
        }else{
          this.disabledCaracter = false;
        }

        if(element.vdate != 'S'){

        }

        if(element.ventero != 'S'){

        }

        if(element.vreal != 'S'){
          this.disabledReal = true;
        }else{
          this.disabledReal = false;
        }

        if(element.vstrg != 'S'){
          this.disabledString = true;
        }else{
          this.disabledString = false;
        }

        if(element.vtime != 'S'){

        }
      }
    });

  }

  guardarClaseAlt() {
    console.log(this.objClaseAltenativa)
    if (this.objClaseAltenativa.clase != null && this.objClaseAltenativa.codigo != null) {
      console.log('entro al foreach clasesselect')
      console.log(this.objClaseAltenativa)

      this.clasesAlternativasSelect.forEach(element => {
        if (element.clase == this.objClaseAltenativa.clase) {
          console.log("el-encontrado" + element)
          this.objClaseAltenativa.desclase = element.descri
        }
      });

      this.unidadesMedidas.forEach(element => {
        if (element.coduni == this.objClaseAltenativa.codigo) {
          console.log("el-encontrado uni" + element)
          this.objClaseAltenativa.descodigo = element.desuni
        }
      });

      this.objClaseAltenativa.codart = this.objarticulo.codart;
      console.log(this.objClaseAltenativa)

      this.spinnerService.activarLoading(true);
      if (this.clasesAlternativas.find(x => x.clase == this.objClaseAltenativa.clase) == null) {
        this.spinnerService.activarLoading(false);
        console.log('Se agrega esto')
        console.log(this.objClaseAltenativa)
        console.log(this.clasesAlternativas)
        this.clasesAlternativas.push(this.objClaseAltenativa)
        this.clasesAlternativas = [...this.clasesAlternativas]
        this.objClaseAltenativa = {}
        this.modal.close();
      } else {
        this.spinnerService.activarLoading(false);
        basicAlert('El código de clase ya existe.', 'warning', 'Aceptar', null, null);
        this.objClaseAltenativa = {}
        return;
      }


    } else {
      //En caso no se llenen los datos necesarios
      var dato = ''
      if (this.objClaseGlobal.clase == null) {
        dato = '"Clase"'
      } else if (this.objClaseGlobal.codigo == null) {
        dato = '"Código"'
      }
      basicAlert("El campo " + dato + "es obligatorio.", 'warning', 'Aceptar');
 
    }
  }

  openModificarClaseAlt(content: string, clase: any) {
    console.log('modificar Clase Global')
    console.log(clase)
    this.objClaseAltenativa = clase
    this.editclaseAlt = clase

    this.clasesAlternativasSelect.forEach(element => {
      if (element.clase == this.objClaseAltenativa.clase) {
      this.disabledCaracter = (element.vchar != 'S' )?true:false;
      this.disabledReal = (element.vreal != 'S' )?true:false;
      this.disabledString = (element.vstrg != 'S' )?true:false;
      }
    });

    this.open(content)

    // this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'lg' }).result.then((result) => {
    //   this.closeResult = `Closed with: ${result}`;
    // }, (reason) => {
    //   this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    // });

  }

  
  guardarActualizarClaseAlt() {

    // this.clasesCodigosGlobal.forEach(element => {
    //   if (element.codigo == this.objClaseGlobal.codigo) {
    //     this.objClaseGlobal.descodigo = element.descri
    //   }
    // });

     this.clasesAlternativasSelect.forEach(element => {
        if (element.clase == this.objClaseAltenativa.clase) {
          console.log("el-encontrado" + element)
          this.objClaseAltenativa.desclase = element.descri
        }
      });

      this.unidadesMedidas.forEach(element => {
        if (element.coduni == this.objClaseAltenativa.codigo) {
          console.log("el-encontrado uni" + element)
          this.objClaseAltenativa.descodigo = element.desuni
        }
      });
      this.objClaseAltenativa.codart = this.objarticulo.codart;

    let arreglo = this.clasesAlternativas;
    let indice = arreglo.indexOf(this.editclaseAlt)
    console.log(indice)
    arreglo[indice] = this.objClaseAltenativa;
 
    this.clasesAlternativas = arreglo
    this.clasesAlternativas = [...this.clasesAlternativas]
    basicAlert('Se actualizó con éxito.', 'success', 'Aceptar', null, null);
    this.modal.close();
    console.log('Asi quedo el arreglo clase')
    console.log(this.clases)
  }

  actualizar(data:any){
    console.log('actualizando data: ',data);
    data.id_cia=this.sessionInfo.id_cia;
    data.observ=data.obs;
    this.spinnerService.activarLoading(true);
    this.articuloService.actualizarAdjuntoArticulo(data).subscribe((resp:any)=>{
      this.spinnerService.activarLoading(false);
      console.log('Se actualizo correctamente');
      this.getAdjuntos()
    }, err => {
      if (err.status == 404) {
        this.spinnerService.activarLoading(false);
        console.log(err);
        basicAlert('Servicio no disponible.', 'warning', 'Aceptar', null, null, null);
      }
    })
  }

  openModalCodCla() {
   const referenciaModal = this.modalService.open(ModalBusquedaCodclaartComponent, { scrollable: true, windowClass: 'modal-lista-articulos', backdrop: 'static' });
   referenciaModal.componentInstance.clasesCodigos = this.clasesCodigos;
   referenciaModal.result.then((data) => {
     console.log(data);
     this.objClaseCodigoDescripcion.codigo = data.codigo;
     this.buscarcodCla = 'borrar';
     this.disabcod = true;
   }, (reason) => {
     console.log(reason);
   });
 }

 borrarDatosCodCla(){
  this.objClaseCodigoDescripcion.codigo = '';
  this.buscarcodCla = 'buscar';
  this.disabcod = false;
 }

 disabcod2 = true
}
